export type ReferencePriceDisplay = { kind: 'private' } | { kind: 'unpriced' } | { kind: 'converted'; amount: number; currency: string } | { kind: 'jpy'; amount: number };

interface ReferencePriceSource {
  isPublicPrice: boolean;
  referencePrice?: number | undefined;
  currencyConvertedPrice?: { amount: number; currency: string } | undefined;
}

// 参考価格の表示規則の正本。詳細ページ・マップピン・検索サジェストが同じ判定を共有する。
export const resolveReferencePriceDisplay = (source: ReferencePriceSource): ReferencePriceDisplay => {
  if (!source.isPublicPrice) return { kind: 'private' };
  if (source.referencePrice == null || source.referencePrice <= 0) return { kind: 'unpriced' };
  if (source.currencyConvertedPrice) return { kind: 'converted', amount: source.currencyConvertedPrice.amount, currency: source.currencyConvertedPrice.currency };
  return { kind: 'jpy', amount: source.referencePrice };
};
